import { render } from "./listGame.html?vue&type=template&id=389b2783"
import script from "./ListGame.vue?vue&type=script&lang=ts"
export * from "./ListGame.vue?vue&type=script&lang=ts"

import "./listGame.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script